define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/action/Controller",
	"csi/comm/PostRequest",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"csi/xml/Query",
	"./StylePushTemplatesForm"
], function(declare,lang,_,Controller,PostRequest,ActionControllerMixin,xml,Query) {

	return declare([Controller, ActionControllerMixin], {

		FIELD_MERCH_PRODUCT_SUBTYPE: "MerchProductSubtype",
		FIELD_TEMPLATE: "Template",

		getWizardViewQuery: function(/*csi.wizard.Widget*/wizard, /*csi.view.Widget*/view, /*Number*/index) {
			// summary: filter nodes by structure item
			var q = this.inherited(arguments);
			if (index == 1) {
				q = new Query();
				var merchProductSubtype = this.m_formData.getFieldValue(this.FIELD_MERCH_PRODUCT_SUBTYPE);
				q.RefAttr("Subtype", xml.OP_EQUALS, merchProductSubtype,  "Child:__Parent__");
			}
			return q;

		},

		onNextPage: function(/*csi.wizard.Widget*/wizard,
				 /*csi.wizard.Content*/currentPage,
				 /*csi.wizard.Content*/nextPage,
				 /*Boolean*/bFinish) {
				// summary: prepare the data and pass it into the next page
			return bFinish ? null : wizard.setFormDataToPage(nextPage, this.m_formData, (wizard.getIndexOfPage(nextPage) == 1));
		},

		/**
		 * Only allow selection of nodes with Write access in this context
		 * @param {FormData} fd
		 */
		onFormData: function(fd) {
			fd.m_fAggregateTest = lang.hitch(this, this._canAggregateStyle);
		},

		/**
		 * See if the style is editable
		 * @param {Context} ctx
		 * @param {FormData} fd
		 */
		_canAggregateStyle: function(ctx, fd) {
			const style = this.m_cache.getNode(ctx.getNode().Style);
			return xml.nodeHasRight(style, xml.RIGHT_WRITE);
		},

		process: function() {
			// summary: issue request as PostRequest so we get return value
			var	fd = this.m_formData;

			var req = new PostRequest("Merchandising", "PushMappingAttributesToStyle")
				.addParameter(xml.PROP_URL_PARENT, this.m_urlParent)
				.addParameter("Template", fd.getFieldValue(this.FIELD_TEMPLATE));

			var	nodes = fd.getSelectedNodes(true);
			if (nodes.length) {
				req.addParameter(xml.PROP_AGGREGATE_ADDS, _.map(nodes, xml.nodeGetURL));
			}

			this.waitForPublish(req.post());
		}

	});
});